import { render, staticRenderFns } from "./SidebarCreateNewUser.vue?vue&type=template&id=ca3c573e&scoped=true"
import script from "./SidebarCreateNewUser.vue?vue&type=script&lang=js"
export * from "./SidebarCreateNewUser.vue?vue&type=script&lang=js"
import style0 from "./SidebarCreateNewUser.vue?vue&type=style&index=0&id=ca3c573e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca3c573e",
  null
  
)

export default component.exports